module.exports = __webpack_public_path__ + "img/17.35ee6f0b.jpg";